
(function () {
  'use strict';

  var CLASE_ABIERTO = 'vqa--abierto';

  var mapaTallas = {};

  var estado = {
    datos: null,
    tarjeta: null,
    disparador: null,
    indiceMedia: 0,
    seleccion: {}
  };


  function $(sel, raiz) { return (raiz || document).querySelector(sel); }
  function $$(sel, raiz) { return Array.prototype.slice.call((raiz || document).querySelectorAll(sel)); }

  function normalizar(t) {
    return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }

  function esOpcionTalla(opcion) {
    for (var i = 0; i < opcion.valores.length; i++) {
      var v = opcion.valores[i];
      if (mapaTallas[v] || /^\s*\d+(?:[.,]\d+)?\s*[x×]\s*\d+/i.test(String(v))) return true;
    }
    return /(^|\b)(size|talla|tamano|format|formato|taille)(\b|$)/.test(normalizar(opcion.nombre));
  }

  function muestrasPropias(refs) {
    var propias = {};
    $$('[data-vqa-acabado]', refs.acabado).forEach(function (b) {
      propias[normalizar(b.getAttribute('data-vqa-acabado'))] = true;
    });
    return propias;
  }
  function esOpcionAcabado(opcion, refs) {
    var propias = muestrasPropias(refs);
    for (var i = 0; i < opcion.valores.length; i++) {
      if (propias[normalizar(opcion.valores[i])]) return true;
    }
    return /(^|\b)(finish|frame|acabado|marco|moldura|finition|cadre)(\b|$)/.test(normalizar(opcion.nombre));
  }
  function todasConMuestra(opcion, refs) {
    var propias = muestrasPropias(refs);
    for (var i = 0; i < opcion.valores.length; i++) {
      if (!propias[normalizar(opcion.valores[i])]) return false;
    }
    return true;
  }

  function esOpcionFicticia(opcion) {
    return normalizar(opcion.nombre) === 'title'
      && opcion.valores.length === 1
      && normalizar(opcion.valores[0]) === 'default title';
  }


  function variantePorSeleccion(datos, seleccion) {
    var nombres = datos.opciones.map(function (o) { return o.nombre; });
    for (var i = 0; i < datos.variantes.length; i++) {
      var v = datos.variantes[i];
      var casa = true;
      for (var j = 0; j < nombres.length; j++) {
        if (seleccion[nombres[j]] !== undefined && v.opts[j] !== seleccion[nombres[j]]) {
          casa = false; break;
        }
      }
      if (casa) return v;
    }
    return null;
  }

  function valorDisponible(datos, nombreOpcion, valor, seleccion) {
    var nombres = datos.opciones.map(function (o) { return o.nombre; });
    var idx = nombres.indexOf(nombreOpcion);
    if (idx === -1) return true;
    return datos.variantes.some(function (v) {
      if (v.opts[idx] !== valor) return false;
      for (var j = 0; j < nombres.length; j++) {
        if (j === idx) continue;
        if (seleccion[nombres[j]] !== undefined && v.opts[j] !== seleccion[nombres[j]]) return false;
      }
      return v.disponible;
    });
  }


  function construir(panel, datos) {
    var refs = panel.__vqaRefs;

    refs.titulo.textContent = datos.titulo;
    refs.enlace.setAttribute('href', datos.url);

    if (refs.artista) {
      var quien = (datos.artista || '').trim();
      refs.artista.textContent = quien;
      refs.artista.hidden = !quien;
    }

    if (refs.wish && datos.handle) {
      refs.wish.setAttribute('data-product-handle', datos.handle);
      var guardado = false;
      try {
        guardado = !!(window.VeeryWishlist && window.VeeryWishlist.has(datos.handle));
      } catch (e) { guardado = false; }
      refs.wish.setAttribute('aria-pressed', guardado ? 'true' : 'false');
      var etiqueta = guardado
        ? refs.wish.getAttribute('data-label-remove')
        : refs.wish.getAttribute('data-label-add');
      if (etiqueta) refs.wish.setAttribute('aria-label', etiqueta);
      var txt = $('.vqa__wish-texto', refs.wish);
      if (txt && etiqueta) txt.textContent = etiqueta;
    }

    if (refs.guiaCaja) refs.guiaCaja.hidden = true;
    if (refs.guiaBtn) refs.guiaBtn.setAttribute('aria-expanded', 'false');

    estado.indiceMedia = 0;
    pintarGaleria(panel, datos);

    estado.seleccion = {};
    var inicial = null;
    for (var i = 0; i < datos.variantes.length; i++) {
      if (datos.variantes[i].id === datos.varianteInicial) { inicial = datos.variantes[i]; break; }
    }
    if (!inicial) inicial = datos.variantes[0];
    if (inicial) {
      datos.opciones.forEach(function (o, idx) { estado.seleccion[o.nombre] = inicial.opts[idx]; });
    }

    pintarOpciones(panel, datos);
    if (refs.cantidad) refs.cantidad.value = '1';
    sincronizar(panel, datos);
  }

  function pintarGaleria(panel, datos) {
    var refs = panel.__vqaRefs;
    var imgs = datos.media;

    refs.puntos.innerHTML = '';
    refs.pista.innerHTML = '';
    refs.imagen = null;
    refs.overlay = null;

    if (!imgs.length) {
      refs.flechaPrev.hidden = true;
      refs.flechaSig.hidden = true;
      return;
    }

    imgs.forEach(function (m, i) {
      var slide = document.createElement('div');
      slide.className = 'vqa__slide';

      var img = document.createElement('img');
      img.className = 'vqa__imagen';
      img.src = m.src;
      img.alt = m.alt || datos.titulo;
      img.decoding = 'async';
      img.width = 800; img.height = 1000;
      if (i > 0) img.loading = 'lazy';
      img.draggable = false;
      slide.appendChild(img);

      if (i === 0) {
        refs.imagen = img;
        var ov = document.createElement('span');
        ov.className = 'vqa__overlay';
        ov.setAttribute('data-vqa-overlay', '');
        ov.setAttribute('aria-hidden', 'true');
        slide.appendChild(ov);
        refs.overlay = ov;
        img.addEventListener('load', function () {
          if (img.naturalWidth && img.naturalHeight) {
            var caja = refs.imagen && refs.imagen.closest('.vqa__lienzo');
            if (caja) caja.style.setProperty('--vqa-ratio', img.naturalWidth + ' / ' + img.naturalHeight);
          }
          posicionarOverlay(refs);
          aplicarMarco(refs);
        });
      }

      refs.pista.appendChild(slide);
    });

    var varias = imgs.length > 1;
    refs.flechaPrev.hidden = !varias;
    refs.flechaSig.hidden = !varias;

    if (varias) {
      imgs.forEach(function (m, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vqa__punto';
        b.setAttribute('data-vqa-punto', String(i));
        b.setAttribute('aria-label', refs.plantillaPunto.replace('__n__', String(i + 1)));
        refs.puntos.appendChild(b);
      });
    }

    estado.indiceMedia = 0;
    refs.pista.style.scrollBehavior = 'auto';
    refs.pista.scrollLeft = 0;
    refs.pista.style.scrollBehavior = '';
    marcarPunto(refs, 0);
  }

  function marcarPunto(refs, indice) {
    var puntos = $$('[data-vqa-punto]', refs.puntos);
    puntos.forEach(function (b, i) {
      var activo = i === indice;
      b.classList.toggle('vqa__punto--activo', activo);
      b.setAttribute('aria-current', activo ? 'true' : 'false');
    });

    if (refs.indice) {
      var dosDigitos = function (n) { return n < 10 ? '0' + n : String(n); };
      refs.indice.textContent = puntos.length > 1
        ? dosDigitos(indice + 1) + ' / ' + dosDigitos(puntos.length)
        : '';
    }
  }

  function mostrarMedia(panel, datos, indice) {
    var refs = panel.__vqaRefs;
    var imgs = datos.media;
    if (!imgs.length || !refs.pista) return;

    var n = imgs.length;
    var i = ((indice % n) + n) % n;
    estado.indiceMedia = i;

    refs.pista.scrollTo({ left: refs.pista.clientWidth * i, behavior: 'smooth' });
    marcarPunto(refs, i);
    aplicarMarco(refs);
  }

  function indiceSegunScroll(refs) {
    var ancho = refs.pista.clientWidth || 1;
    return Math.round(refs.pista.scrollLeft / ancho);
  }

  function pintarOpciones(panel, datos) {
    var refs = panel.__vqaRefs;
    refs.talla.innerHTML = '';
    refs.otras.innerHTML = '';
    $$('[data-vqa-acabado]', refs.acabado).forEach(function (b) { b.hidden = true; });

    var hayTalla = false, hayAcabado = false;

    datos.opciones.forEach(function (opcion) {
      if (esOpcionFicticia(opcion)) return;

      if (esOpcionAcabado(opcion, refs) && todasConMuestra(opcion, refs)) {
        hayAcabado = true;
        configurarAcabados(refs, opcion);
      } else {
        var esTalla = esOpcionTalla(opcion);
        var destino = esTalla ? refs.talla : refs.otras;
        if (esTalla) hayTalla = true;
        destino.appendChild(desplegable(datos, opcion));
      }
    });

    refs.filaTalla.hidden = !hayTalla && !refs.otras.children.length;
    refs.filaAcabado.hidden = !hayAcabado;
  }

  function desplegable(datos, opcion) {
    var envoltura = document.createElement('div');
    envoltura.className = 'vqa__select-caja';

    var sel = document.createElement('select');
    sel.className = 'vqa__select';
    sel.setAttribute('data-vqa-opcion', opcion.nombre);
    sel.setAttribute('aria-label', opcion.nombre);

    var esTalla = esOpcionTalla(opcion);

    opcion.valores.forEach(function (valor) {
      var op = document.createElement('option');
      op.value = valor;
      var humano = esTalla ? mapaTallas[valor] : null;
      op.textContent = humano || valor;
      if (estado.seleccion[opcion.nombre] === valor) op.selected = true;
      sel.appendChild(op);
    });

    envoltura.appendChild(sel);

    var chevron = document.createElement('span');
    chevron.className = 'vqa__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    envoltura.appendChild(chevron);

    return envoltura;
  }

  function configurarAcabados(refs, opcion) {
    var ofrecidos = {};
    opcion.valores.forEach(function (v) { ofrecidos[normalizar(v)] = v; });

    $$('[data-vqa-acabado]', refs.acabado).forEach(function (b) {
      var etiqueta = b.getAttribute('data-vqa-acabado');
      var valorReal = ofrecidos[normalizar(etiqueta)];
      if (!valorReal) { b.hidden = true; return; }

      b.hidden = false;
      b.setAttribute('data-vqa-valor', valorReal);
      b.setAttribute('data-vqa-opcion-nombre', opcion.nombre);
      var elegido = estado.seleccion[opcion.nombre] === valorReal;
      b.setAttribute('aria-checked', elegido ? 'true' : 'false');
      b.tabIndex = elegido ? 0 : -1;
    });

    var visibles = $$('[data-vqa-acabado]', refs.acabado).filter(function (b) { return !b.hidden; }).length;
    refs.acabado.style.setProperty('--vqa-marcos-n', String(Math.max(visibles, 1)));
  }


  function activarArrastre(panel) {
    var refs = panel.__vqaRefs;
    var pista = refs.pista;
    if (!pista) return;

    var abajo = false, arrastrando = false, huboArrastre = false;
    var inicioX = 0, inicioScroll = 0, pointerId = null;
    var UMBRAL = 8;

    pista.addEventListener('dragstart', function (ev) { ev.preventDefault(); });

    pista.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType !== 'mouse' || ev.button !== 0) return;
      abajo = true; arrastrando = false; huboArrastre = false;
      inicioX = ev.clientX;
      inicioScroll = pista.scrollLeft;
      pointerId = ev.pointerId;
    });

    pista.addEventListener('pointermove', function (ev) {
      if (!abajo) return;
      var dx = ev.clientX - inicioX;
      if (!arrastrando && Math.abs(dx) > UMBRAL) {
        arrastrando = true; huboArrastre = true;
        pista.classList.add('vqa--arrastrando');
        try { pista.setPointerCapture(pointerId); } catch (e) {}
      }
      if (arrastrando) {
        ev.preventDefault();
        pista.scrollLeft = inicioScroll - dx;
      }
    });

    function fin() {
      if (!abajo) return;
      abajo = false;
      if (!arrastrando) { pointerId = null; return; }
      try { if (pointerId !== null) pista.releasePointerCapture(pointerId); } catch (e) {}
      arrastrando = false; pointerId = null;
      pista.classList.remove('vqa--arrastrando');

      var i = indiceSegunScroll(refs);
      estado.indiceMedia = i;
      pista.scrollTo({ left: pista.clientWidth * i, behavior: 'smooth' });
      marcarPunto(refs, i);
      aplicarMarco(refs);
    }

    pista.addEventListener('pointerup', fin);
    pista.addEventListener('pointercancel', fin);
    pista.addEventListener('pointerleave', fin);

    pista.addEventListener('click', function (ev) {
      if (huboArrastre) { ev.preventDefault(); ev.stopPropagation(); huboArrastre = false; }
    }, true);

    var t = null;
    pista.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = indiceSegunScroll(refs);
        if (i === estado.indiceMedia) return;
        estado.indiceMedia = i;
        marcarPunto(refs, i);
        aplicarMarco(refs);
      }, 90);
    }, { passive: true });
  }


  function posicionarOverlay(refs) {
    var caja = refs.obra, img = refs.imagen, ov = refs.overlay;
    if (!caja || !img || !ov) return;

    var cajaW = caja.clientWidth, cajaH = caja.clientHeight;
    if (!cajaW || !cajaH) return;

    var aire = parseFloat(getComputedStyle(img).paddingLeft) || 0;
    var zonaW = cajaW - 2 * aire;
    var zonaH = cajaH - 2 * aire;
    if (zonaW <= 0 || zonaH <= 0) return;

    var r = (img.naturalWidth && img.naturalHeight)
      ? (img.naturalWidth / img.naturalHeight)
      : (cajaW / cajaH);

    var w, h;
    if (r > zonaW / zonaH) { w = zonaW; h = w / r; }
    else { h = zonaH; w = h * r; }

    ov.style.setProperty('--vqa-rect-left', ((cajaW - w) / 2) + 'px');
    ov.style.setProperty('--vqa-rect-top', ((cajaH - h) / 2) + 'px');
    ov.style.setProperty('--vqa-rect-w', w + 'px');
    ov.style.setProperty('--vqa-rect-h', h + 'px');
  }

  function aplicarMarco(refs) {
    var ov = refs.overlay;
    if (!ov) return;

    var elegido = $$('[data-vqa-acabado]', refs.acabado).filter(function (b) {
      return !b.hidden && b.getAttribute('aria-checked') === 'true';
    })[0];

    var url = elegido && elegido.getAttribute('data-vqa-overlay');
    var sinMarco = elegido && elegido.hasAttribute('data-vqa-sin-marco');
    var esLaObra = estado.indiceMedia === 0;

    if (!elegido || sinMarco || !url || !esLaObra) {
      ov.classList.remove('vqa--visible');
      return;
    }
    ov.style.setProperty('--vqa-overlay-url', 'url("' + url + '")');
    ov.classList.add('vqa--visible');
  }

  function sincronizar(panel, datos) {
    var refs = panel.__vqaRefs;
    var v = variantePorSeleccion(datos, estado.seleccion);

    var precio = v ? v.precio : datos.precio;
    var precioCorto = v && v.precioCorto ? v.precioCorto : precio;
    refs.precio.textContent = precio;
    refs.ctaPrecio.textContent = precioCorto;

    var comprable = !!(v && v.disponible);
    refs.cta.disabled = !comprable;
    refs.cta.setAttribute('aria-disabled', comprable ? 'false' : 'true');
    refs.ctaTexto.textContent = comprable ? refs.textoAnadir : refs.textoAgotado;
    refs.ctaPrecio.hidden = !comprable;
    if (refs.ctaSep) refs.ctaSep.hidden = !comprable;

    $$('[data-vqa-acabado]', refs.acabado).forEach(function (b) {
      if (b.hidden) return;
      var nombre = b.getAttribute('data-vqa-opcion-nombre');
      var valor = b.getAttribute('data-vqa-valor');
      var hay = valorDisponible(datos, nombre, valor, estado.seleccion);
      b.classList.toggle('vqa__marco--agotado', !hay);
      var elegido = estado.seleccion[nombre] === valor;
      b.setAttribute('aria-checked', elegido ? 'true' : 'false');
      b.tabIndex = elegido ? 0 : -1;
    });

    posicionarOverlay(refs);
    aplicarMarco(refs);

    if (v) {
      refs.anuncio.textContent = v.titulo + ' · ' + precio +
        (comprable ? '' : ' · ' + refs.textoAgotado);
    }
  }


  var guias = {};

  function urlGuia(datos) {
    if (!datos || !datos.url) return '';
    return String(datos.url).split('#')[0].split('?')[0] + '?section_id=veery-guia-rapida';
  }

  function pedirGuia(datos) {
    var url = urlGuia(datos);
    if (!url) return Promise.reject(new Error('sin url'));
    if (!guias[url]) {
      guias[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        if (html.indexOf('data-vsg-open') === -1) throw new Error('sin guía');
        return html;
      });
      guias[url].catch(function () { delete guias[url]; });
    }
    return guias[url];
  }

  function montarGuia(panel, html, url) {
    var host = $('[data-vqa-guia-host]', panel);
    if (!host) {
      host = document.createElement('div');
      host.className = 'vqa__guia-host';
      host.setAttribute('data-vqa-guia-host', '');
      panel.appendChild(host);
    }
    if (host.getAttribute('data-vqa-guia-url') === url) return host;
    host.innerHTML = html;
    host.setAttribute('data-vqa-guia-url', url);
    $$('script', host).forEach(function (viejo) {
      var nuevo = document.createElement('script');
      for (var i = 0; i < viejo.attributes.length; i++) nuevo.setAttribute(viejo.attributes[i].name, viejo.attributes[i].value);
      nuevo.textContent = viejo.textContent;
      viejo.parentNode.replaceChild(nuevo, viejo);
    });
    return host;
  }

  function seleccionParaGuia(panel, datos) {
    var refs = panel.__vqaRefs;
    var r = { talla: '', marco: '' };
    datos.opciones.forEach(function (o) {
      var v = estado.seleccion[o.nombre];
      if (v === undefined || esOpcionFicticia(o)) return;
      if (esOpcionAcabado(o, refs)) r.marco = v;
      else if (esOpcionTalla(o)) r.talla = v;
    });
    return r;
  }

  function alternarTabla(panel) {
    var refs = panel.__vqaRefs;
    if (!refs.guiaCaja) return;
    var abierta = !refs.guiaCaja.hidden;
    refs.guiaCaja.hidden = abierta;
    if (refs.guiaBtn) refs.guiaBtn.setAttribute('aria-expanded', abierta ? 'false' : 'true');
  }

  function abrirGuia(panel) {
    var datos = estado.datos;
    var url = urlGuia(datos);
    pedirGuia(datos).then(function (html) {
      if (estado.datos !== datos || !panel.open) return;
      var host = montarGuia(panel, html, url);
      var abridor = $('[data-vsg-open]', host);
      var ventana = abridor && document.getElementById(abridor.getAttribute('data-vsg-open'));
      if (!ventana) throw new Error('guía incompleta');
      ventana.setAttribute('data-vsg-destino', 'compra-rapida');
      ventana.setAttribute('data-vsg-inicial', JSON.stringify(seleccionParaGuia(panel, datos)));
      abridor.click();
    }).catch(function () {
      if (estado.datos === datos && panel.open) alternarTabla(panel);
    });
  }

  function aplicarDesdeGuia(panel, detalle) {
    var datos = estado.datos;
    if (!datos || !detalle) return;
    var refs = panel.__vqaRefs;
    datos.opciones.forEach(function (o) {
      if (esOpcionFicticia(o)) return;
      var buscado = esOpcionAcabado(o, refs) ? detalle.marcoEtiqueta : (esOpcionTalla(o) ? detalle.talla : '');
      if (!buscado) return;
      for (var i = 0; i < o.valores.length; i++) {
        if (normalizar(o.valores[i]) === normalizar(buscado)) { estado.seleccion[o.nombre] = o.valores[i]; break; }
      }
    });
    pintarOpciones(panel, datos);
    sincronizar(panel, datos);
  }

  function anadir(panel) {
    var datos = estado.datos;
    if (!datos || !estado.tarjeta) return;

    var v = variantePorSeleccion(datos, estado.seleccion);
    if (!v || !v.disponible) return;

    var form = estado.tarjeta.querySelector('form.shopify-product-form');
    if (!form) return;

    var inputId = form.querySelector('input[name="id"]');
    var inputCantidad = form.querySelector('input[name="quantity"]');
    if (!inputId) return;

    inputId.value = String(v.id);
    inputId.disabled = false;
    if (inputCantidad) inputCantidad.value = String(cantidadActual(panel));

    panel.__vqaRefs.cta.classList.add('vqa__cta--cargando');

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  function cantidadActual(panel) {
    if (!panel.__vqaRefs.cantidad) return 1;
    var n = parseInt(panel.__vqaRefs.cantidad.value, 10);
    if (!isFinite(n) || n < 1) n = 1;
    return n;
  }


  function abrir(panel, boton) {
    var tarjeta = boton.closest('.bse__card');
    if (!tarjeta) return;

    var bloque = tarjeta.querySelector('[data-vqa-datos]');
    if (!bloque) return;

    var datos;
    try { datos = JSON.parse(bloque.textContent); } catch (e) { return; }
    if (!datos || !datos.variantes || !datos.variantes.length) return;

    estado.datos = datos;
    estado.tarjeta = tarjeta;
    estado.disparador = boton;

    construir(panel, datos);
    panel.classList.add(CLASE_ABIERTO);
    if (!panel.open) panel.showModal();
    pedirGuia(datos).catch(function () {});
  }

  function cerrar(panel) {
    if (!panel.open) return;
    panel.classList.remove(CLASE_ABIERTO);
    panel.close();
    restaurarFoco();
  }

  function restaurarFoco() {
    var disp = estado.disparador;
    estado.disparador = null;
    if (!disp || !document.contains(disp)) return;

    var caja = disp.closest('.bse__quick');
    if (caja) {
      caja.classList.add('bse__quick--foco');
      disp.addEventListener('blur', function quitar() {
        caja.classList.remove('bse__quick--foco');
        disp.removeEventListener('blur', quitar);
      });
    }
    disp.focus();
  }


  function iniciar() {
    var todos = document.querySelectorAll('#veery-quick-add');
    for (var d = todos.length - 1; d > 0; d--) {
      if (todos[d].parentNode) todos[d].parentNode.removeChild(todos[d]);
    }

    var panel = document.getElementById('veery-quick-add');
    if (!panel || panel.__vqaListo) return;
    panel.__vqaListo = true;

    var bloqueTallas = $('[data-vqa-tallas]', panel);
    if (bloqueTallas) {
      try { mapaTallas = JSON.parse(bloqueTallas.textContent) || {}; } catch (e) { mapaTallas = {}; }
    }

    panel.__vqaRefs = {
      titulo: $('[data-vqa-titulo]', panel),
      precio: $('[data-vqa-precio]', panel),
      imagen: null,
      overlay: null,
      obra: $('.vqa__obra', panel),
      pista: $('[data-vqa-pista]', panel),
      puntos: $('[data-vqa-puntos]', panel),
      flechaPrev: $('[data-vqa-prev]', panel),
      flechaSig: $('[data-vqa-sig]', panel),
      filaTalla: $('[data-vqa-fila-talla]', panel),
      talla: $('[data-vqa-talla]', panel),
      otras: $('[data-vqa-otras]', panel),
      filaAcabado: $('[data-vqa-fila-acabado]', panel),
      acabado: $('[data-vqa-acabado-lista]', panel),
      cantidad: $('[data-vqa-cantidad]', panel),
      cta: $('[data-vqa-cta]', panel),
      ctaTexto: $('[data-vqa-cta-texto]', panel),
      ctaPrecio: $('[data-vqa-cta-precio]', panel),
      ctaSep: $('.vqa__cta-sep', panel),
      enlace: $('[data-vqa-enlace]', panel),
      indice: $('[data-vqa-indice]', panel),
      artista: $('[data-vqa-artista]', panel),
      wish: $('[data-veery-wishlist]', panel),
      guiaBtn: $('[data-vqa-guia]', panel),
      guiaCaja: $('[data-vqa-guia-caja]', panel),
      anuncio: $('[data-vqa-anuncio]', panel),
      textoAnadir: panel.getAttribute('data-texto-anadir') || 'Add to cart',
      textoAgotado: panel.getAttribute('data-texto-agotado') || 'Sold out',
      plantillaPunto: panel.getAttribute('data-texto-punto') || 'Image __n__'
    };

    if (!window.__vqaDelegacionRegistrada) {
      window.__vqaDelegacionRegistrada = true;

      document.addEventListener('click', function (e) {
        var boton = e.target.closest && e.target.closest('[data-vqa-abrir]');
        if (!boton) return;
        var vivo = document.getElementById('veery-quick-add');
        if (!vivo) return;
        e.preventDefault();
        abrir(vivo, boton);
      });

      document.addEventListener('cart:update', function (e) {
        var vivo = document.getElementById('veery-quick-add');
        if (!vivo || !vivo.__vqaRefs || !vivo.__vqaRefs.cta) return;
        if (e.detail && e.detail.data && e.detail.data.didError) {
          vivo.__vqaRefs.cta.classList.remove('vqa__cta--cargando');
          return;
        }
        if (vivo.open) cerrar(vivo);
      });

      document.addEventListener('cart:error', function () {
        var vivo = document.getElementById('veery-quick-add');
        if (!vivo || !vivo.__vqaRefs || !vivo.__vqaRefs.cta) return;
        vivo.__vqaRefs.cta.classList.remove('vqa__cta--cargando');
      });
    }

    panel.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;

      if (t.closest('[data-vqa-cerrar]')) { cerrar(panel); return; }
      if (t.closest('[data-vqa-prev]')) { mostrarMedia(panel, estado.datos, estado.indiceMedia - 1); return; }
      if (t.closest('[data-vqa-sig]')) { mostrarMedia(panel, estado.datos, estado.indiceMedia + 1); return; }

      var punto = t.closest('[data-vqa-punto]');
      if (punto) { mostrarMedia(panel, estado.datos, parseInt(punto.getAttribute('data-vqa-punto'), 10)); return; }

      var marco = t.closest('[data-vqa-acabado]');
      if (marco) {
        estado.seleccion[marco.getAttribute('data-vqa-opcion-nombre')] = marco.getAttribute('data-vqa-valor');
        sincronizar(panel, estado.datos);
        marco.focus();
        return;
      }

      if (t.closest('[data-vqa-guia]')) { abrirGuia(panel); return; }

      var menos = t.closest('[data-vqa-menos]');
      if (menos) { ajustarCantidad(panel, -1); return; }
      var mas = t.closest('[data-vqa-mas]');
      if (mas) { ajustarCantidad(panel, 1); return; }

      if (t.closest('[data-vqa-cta]')) { anadir(panel); return; }
    });

    panel.addEventListener('vsg:elegida', function (e) {
      aplicarDesdeGuia(panel, e.detail);
    });

    panel.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-vqa-opcion]');
      if (!sel) return;
      estado.seleccion[sel.getAttribute('data-vqa-opcion')] = sel.value;
      sincronizar(panel, estado.datos);
    });

    panel.addEventListener('keydown', function (e) {
      var marco = e.target.closest && e.target.closest('[data-vqa-acabado]');
      if (!marco) return;
      var dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1
              : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
      if (!dir) return;
      e.preventDefault();
      var todos = $$('[data-vqa-acabado]', panel.__vqaRefs.acabado);
      var i = todos.indexOf(marco);
      var siguiente = todos[(i + dir + todos.length) % todos.length];
      if (!siguiente) return;
      estado.seleccion[siguiente.getAttribute('data-vqa-opcion-nombre')] = siguiente.getAttribute('data-vqa-valor');
      sincronizar(panel, estado.datos);
      siguiente.focus();
    });

    panel.addEventListener('mousedown', function (e) {
      if (e.target !== panel) return;
      var r = panel.getBoundingClientRect();
      var dentro = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!dentro) cerrar(panel);
    });

    panel.addEventListener('close', function () {
      panel.classList.remove(CLASE_ABIERTO);
      panel.__vqaRefs.cta.classList.remove('vqa__cta--cargando');
      restaurarFoco();
    });


    activarArrastre(panel);

    var temporizadorResize = null;
    window.addEventListener('resize', function () {
      if (!panel.open) return;
      clearTimeout(temporizadorResize);
      temporizadorResize = setTimeout(function () {
        posicionarOverlay(panel.__vqaRefs);
      }, 120);
    });


  }

  function ajustarCantidad(panel, delta) {
    var input = panel.__vqaRefs.cantidad;
    if (!input) return;
    var n = parseInt(input.value, 10);
    if (!isFinite(n)) n = 1;
    n = Math.max(1, n + delta);
    input.value = String(n);
    panel.__vqaRefs.menosDeshabilitado = n <= 1;
    var menos = $('[data-vqa-menos]', panel);
    if (menos) menos.disabled = n <= 1;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  document.addEventListener('shopify:section:load', iniciar);
})();
